module.exports = __webpack_public_path__ + "static/media/mosk_extra-bold_800-webfont.77071fdd.woff";